import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const Row = props => {
    const RowSizes = ['small', 'medium', 'large'];
    const rowClasses = ['row'];
    if (props.collapse) {
        if (props.collapse === true) {
            rowClasses.push('collapse');
        }
        else {
            RowSizes.forEach(size => {
                if (props.collapse[size]) {
                    rowClasses.push(size + '-collapse');
                }
            });
        }
    }
    if (props.uncollapse) {
        RowSizes.forEach(size => {
            if (props.uncollapse[size]) {
                rowClasses.push(size + '-uncollapse');
            }
        });
    }
    if (props.className) {
        rowClasses.push(props.className);
    }
    return (_jsx("div", { className: cx(rowClasses), onClick: props.onClick, "data-elm-id": props.elmId, children: props.children }));
};
Row.propTypes = {
    collapse: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.shape({
            small: PropTypes.bool,
            medium: PropTypes.bool,
            large: PropTypes.bool,
        }),
    ]),
    uncollapse: PropTypes.shape({
        small: PropTypes.bool,
        medium: PropTypes.bool,
        large: PropTypes.bool,
    }),
    children: PropTypes.node,
    className: PropTypes.string,
    onClick: PropTypes.func,
    elmId: PropTypes.string,
};
const Column = props => {
    const ColumnSizes = ['small', 'medium', 'large', 'print'];
    const columnClasses = ['column', props.className];
    ColumnSizes.forEach(size => {
        if (props[size]) {
            columnClasses.push(size + '-' + props[size]);
        }
        if (props.offset && typeof props.offset[size] !== 'undefined') {
            columnClasses.push(size + '-offset-' + props.offset[size]);
        }
        if (props.push && typeof props.push[size] !== 'undefined') {
            columnClasses.push(size + '-push-' + props.push[size]);
        }
        if (props.pull && typeof props.pull[size] !== 'undefined') {
            columnClasses.push(size + '-pull-' + props.pull[size]);
        }
        if (props.end) {
            columnClasses.push('end');
        }
    });
    return (_jsx("div", { className: cx(columnClasses), onClick: props.onClick, "data-elm-id": props.elmId, children: props.children }));
};
Column.propTypes = {
    className: PropTypes.string,
    small: PropTypes.number,
    medium: PropTypes.number,
    large: PropTypes.number,
    offset: PropTypes.shape({
        small: PropTypes.number,
        medium: PropTypes.number,
        large: PropTypes.number,
        print: PropTypes.number,
    }),
    push: PropTypes.shape({
        small: PropTypes.number,
        medium: PropTypes.number,
        large: PropTypes.number,
        print: PropTypes.number,
    }),
    pull: PropTypes.shape({
        small: PropTypes.number,
        medium: PropTypes.number,
        large: PropTypes.number,
        print: PropTypes.number,
    }),
    end: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.node,
    elmId: PropTypes.string,
};
const CenteredRow = ({ children, elmId }) => (_jsx(Row, { children: _jsx(Column, { elmId: elmId, medium: 12, className: cx('centered-row'), children: children }) }));
CenteredRow.propTypes = {
    children: PropTypes.node,
    elmId: PropTypes.string,
};
const GridDeprecated = { Row, Column, CenteredRow };
export default GridDeprecated;
//# sourceMappingURL=index.js.map